import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3331f0c6"),n=n(),_popScopeId(),n)
const _hoisted_1 = { id: "outer-container" }
const _hoisted_2 = { id: "inner-container" }
const _hoisted_3 = { id: "message-container" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { id: "icon-container" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "fa fa-exclamation-circle" })
], -1))
const _hoisted_5 = { id: "error-message" }
const _hoisted_6 = { id: "button-container" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fa mr-2 fa-arrow-right" }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _hoisted_4,
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("span", null, _toDisplayString(_ctx.errorMessage), 1)
          ])
        ]),
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("button", {
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.handleClick && _ctx.handleClick(...args)))
          }, [
            _hoisted_7,
            _createElementVNode("span", null, _toDisplayString(_ctx.$t('btn.exit_test')), 1)
          ])
        ])
      ])
    ])
  ]))
}